import { useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Icon } from "./Icons.jsx";
import Analytics from "./Analytics.jsx";

const navLinks = [
  { to: "/techniques", label: "112 Techniques" },
  { to: "/find-my-doorway", label: "Find My Doorway" },
  { to: "/beginner-path", label: "Beginner Path" },
  { to: "/40-day-challenge", label: "40-Day Challenge" },
  { to: "/published-books", label: "Books" },
  { to: "/about", label: "About" },
];

function BrandMark() {
  return (
    <svg viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke="#E5C16A" strokeWidth="1" opacity="0.4" />
      <circle cx="20" cy="20" r="12" stroke="#E5C16A" strokeWidth="1" opacity="0.6" />
      <circle cx="20" cy="20" r="6" stroke="#D9902F" strokeWidth="1.2" />
      <circle cx="20" cy="20" r="1.6" fill="#E5C16A" />
      <circle cx="20" cy="2" r="1" fill="#E5C16A" />
      <circle cx="20" cy="38" r="1" fill="#E5C16A" />
      <circle cx="2" cy="20" r="1" fill="#E5C16A" />
      <circle cx="38" cy="20" r="1" fill="#E5C16A" />
    </svg>
  );
}

function Header() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Link to="/" className="brand" aria-label="Simple Meditation World, home">
          <div className="brand-mark"><BrandMark /></div>
          <div className="brand-name">Simple Meditation <em>World</em></div>
        </Link>
        <div className="nav-links">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to}>{l.label}</NavLink>
          ))}
        </div>
        <Link className="nav-cta" to="/find-my-doorway">Find My Technique {Icon.arrowSm()}</Link>
        <button
          className="nav-burger"
          aria-label="Menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >☰</button>
      </div>
      {open && (
        <div className="nav-mobile" role="menu">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}>{l.label}</NavLink>
          ))}
          <Link to="/find-my-doorway" onClick={() => setOpen(false)}>Find My Technique →</Link>
          <Link to="/journal" onClick={() => setOpen(false)}>Practice Journal</Link>
          <Link to="/sign-in" onClick={() => setOpen(false)}>Sign in</Link>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  const cols = [
    {
      h: "Explore",
      items: [
        ["112 Techniques", "/techniques"],
        ["Find My Doorway", "/find-my-doorway"],
        ["Beginner Path", "/beginner-path"],
        ["40-Day Challenge", "/40-day-challenge"],
        ["Published Books", "/published-books"],
        ["Modern Life Practices", "/techniques?family=daily"],
      ],
    },
    {
      h: "Practice Families",
      items: [
        ["Breath", "/techniques?family=breath"],
        ["Sound", "/techniques?family=sound"],
        ["Body", "/techniques?family=body"],
        ["Emotion", "/techniques?family=emotion"],
        ["Space", "/techniques?family=space"],
        ["Sleep", "/techniques?family=sleep"],
        ["Love", "/techniques?family=love"],
        ["Daily Life", "/techniques?family=daily"],
      ],
    },
    {
      h: "Learn",
      items: [
        ["About Vigyan Bhairava Tantra", "/about"],
        ["Published Books", "/published-books"],
        ["How to Practice", "/about#how"],
        ["Common Mistakes", "/about#mistakes"],
        ["Practice Journal", "/journal"],
      ],
    },
    {
      h: "Simple Meditation World",
      items: [
        ["About", "/about"],
        ["Books", "/published-books"],
        ["Sign in", "/sign-in"],
        ["Journal", "/journal"],
      ],
    },
  ];
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand" style={{ marginBottom: 4 }}>
              <div className="brand-mark"><BrandMark /></div>
              <div className="brand-name">Simple Meditation <em>World</em></div>
            </Link>
            <p>112 ancient doorways into meditation, translated into simple practices for the modern mind. No belief required. Only direct experience.</p>
          </div>
          {cols.map((c) => (
            <div key={c.h} className="footer-col">
              <h4>{c.h}</h4>
              <ul>
                {c.items.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith("/") ? <Link to={href}>{label}</Link> : <a href={href}>{label}</a>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>© 2026 Simple Meditation World. Ancient wisdom, simplified for modern life.</span>
          <span className="om" aria-hidden="true">॥ ॐ ॥</span>
        </div>
      </div>
    </footer>
  );
}

export default function Layout() {
  const { pathname } = useLocation();
  return (
    <>
      <a href="#main" className="skip-link">Skip to content</a>
      <Header />
      <main id="main" tabIndex={-1} data-route={pathname}>
        <Outlet />
      </main>
      <Footer />
      <Analytics />
    </>
  );
}
